/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffDocument } from './StaffDocument';
import {
    StaffDocumentFromJSON,
    StaffDocumentFromJSONTyped,
    StaffDocumentToJSON,
    StaffDocumentToJSONTyped,
} from './StaffDocument';

/**
 * 
 * @export
 * @interface StaffDocumentResponse
 */
export interface StaffDocumentResponse {
    /**
     * 
     */
    data: StaffDocument;
}

/**
 * Check if a given object implements the StaffDocumentResponse interface.
 */
export function instanceOfStaffDocumentResponse(value: object): value is StaffDocumentResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function StaffDocumentResponseFromJSON(json: any): StaffDocumentResponse {
    return StaffDocumentResponseFromJSONTyped(json, false);
}

export function StaffDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': StaffDocumentFromJSON(json['data']),
    };
}

export function StaffDocumentResponseToJSON(json: any): StaffDocumentResponse {
    return StaffDocumentResponseToJSONTyped(json, false);
}

export function StaffDocumentResponseToJSONTyped(value?: StaffDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StaffDocumentToJSON(value['data']),
    };
}

